import React, { useState } from "react";
import { Heart, Lock, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Hearts from "@/components/Hearts";
import LoginBackdrop from "@/components/LoginBackdrop";
import { useAuth } from "@/lib/AuthContext";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(username, password);
      if (data.role === "admin") {
        toast.success("Bienvenue, Guillian", { description: "Mode administrateur activé." });
      } else {
        toast.success("Bienvenue, Amor", { description: "Connexion réussie" });
      }
    } catch (err) {
      toast.error("Identifiants incorrects", { description: "Réessaie." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden grain flex items-center justify-center p-6">
      <Hearts count={14} />
      <LoginBackdrop />

      <div
        data-testid="login-card"
        className="relative z-10 w-full max-w-md romantic-card rounded-2xl p-10 reveal"
      >
        <div className="flex flex-col items-center gap-2 mb-8">
          <div className="w-14 h-14 rounded-full bg-rose-900/30 border border-rose-700/30 flex items-center justify-center">
            <Heart className="w-7 h-7 text-rose-400" fill="currentColor" />
          </div>
          <p className="font-accent text-3xl text-rose-300">Notre histoire</p>
          <h1 className="font-serif text-4xl text-rose-50 tracking-tight">Bienvenue</h1>
          <p className="text-rose-200/70 text-sm">Connecte-toi pour ouvrir nos souvenirs</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="username" className="text-rose-200/90 font-sans tracking-wide text-xs uppercase">
              Identifiant
            </Label>
            <Input
              id="username"
              data-testid="login-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              placeholder="Ton identifiant"
              className="bg-[#1A0A0E]/80 border-rose-900/40 text-rose-50 placeholder:text-rose-200/30 h-12"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-rose-200/90 font-sans tracking-wide text-xs uppercase">
              Mot de passe
            </Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="••••••"
              className="bg-[#1A0A0E]/80 border-rose-900/40 text-rose-50 placeholder:text-rose-200/30 h-12"
            />
          </div>

          <Button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-rose-600 hover:bg-rose-500 text-white font-medium tracking-wide rounded-full transition-all duration-300 hover:shadow-[0_0_30px_rgba(230,57,70,0.45)]"
          >
            <Lock className="w-4 h-4 mr-2" />
            {loading ? "Connexion..." : "Entrer dans notre monde"}
          </Button>
        </form>

        <p className="text-center text-rose-200/40 text-xs mt-8 font-accent text-lg flex items-center justify-center gap-2">
          <ShieldCheck className="w-3.5 h-3.5" />
          Pour toujours, pour toi ♡
        </p>
      </div>
    </div>
  );
}
